import React, { Component } from "react";

/*
  Reusable multi-select dropdown (checkbox list with "Select All").
  Props:
    label    : string                       — field label
    options  : [{ value, label }]           — selectable options
    value    : [valueA, valueB, ...]         — currently selected values (array)
    onChange : (nextValuesArray) => void     — called with the new array
    placeholder : string                     — shown when nothing selected (default "All")
    minWidth : number                        — control min width (default 160)
*/
class MultiSelectDropdown extends Component {
  state = { open: false };
  ref = React.createRef();

  componentDidMount() {
    document.addEventListener("mousedown", this.handleOutside);
  }
  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleOutside);
  }
  handleOutside = (e) => {
    if (this.ref.current && !this.ref.current.contains(e.target)) this.setState({ open: false });
  };

  toggle = (val) => {
    const cur = this.props.value || [];
    const has = cur.some((v) => String(v) === String(val));
    const next = has ? cur.filter((v) => String(v) !== String(val)) : [...cur, val];
    this.props.onChange(next);
  };

  selectAll = (checked) => {
    this.props.onChange(checked ? (this.props.options || []).map((o) => o.value) : []);
  };

  render() {
    const { label, options = [], value = [], placeholder = "All", minWidth = 160, disabled = false } = this.props;
    const open = this.state.open && !disabled;
    // const allChecked = options.length > 0 && options.every((o) => value.some((v) => String(v) === String(o.value)));
    // Count only the selections that are among the currently shown options — `value` may hold
    // stale/out-of-scope ids (e.g. sections outside the selected Branch/Class), so counting the
    // raw array would over-report (show "All (70)" when only 12 options are listed).
    const selectedCount = options.reduce((n, o) => n + (value.some((v) => String(v) === String(o.value)) ? 1 : 0), 0);
    const allChecked = options.length > 0 && selectedCount === options.length;
    const ctrl = { borderRadius: 9, border: "1.5px solid #e5e7eb", padding: "8px 10px", fontSize: 13, color: disabled ? "#cbd5e1" : "#1f2937", background: disabled ? "#f1f5f9" : "#f9fafb", minWidth, display: "flex", alignItems: "center", justifyContent: "space-between", cursor: disabled ? "not-allowed" : "pointer", gap: 8, opacity: disabled ? 0.7 : 1 };
    // const summary = !value.length
    //   ? placeholder
    //   : (allChecked ? `All (${value.length})` : `${value.length} selected`);
    const summary = !selectedCount
      ? placeholder
      : (allChecked ? `All (${options.length})` : `${selectedCount} selected`);

    return (
      <div style={{ display: "flex", flexDirection: "column", gap: 4 }} ref={this.ref}>
        <label style={{ fontSize: 11, fontWeight: 700, color: disabled ? "#cbd5e1" : "#64748b", textTransform: "uppercase", letterSpacing: 0.3 }}>{label}</label>
        <div style={{ position: "relative" }}>
          <div onClick={() => { if (!disabled) this.setState({ open: !this.state.open }); }} style={ctrl}>
            <span style={{ color: value.length ? (disabled ? "#94a3b8" : "#1f2937") : "#9ca3af", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{summary}</span>
            <i className="fal fa-chevron-down" style={{ fontSize: 11, color: "#94a3b8" }} />
          </div>
          {open && (
            <div style={{ position: "absolute", zIndex: 30, top: "calc(100% + 4px)", left: 0, minWidth: Math.max(minWidth, 200), maxHeight: 260, overflowY: "auto", background: "#fff", border: "1px solid #e2e8f0", borderRadius: 10, boxShadow: "0 6px 20px rgba(0,0,0,0.12)", padding: 6 }}>
              {options.length === 0 ? (
                <div style={{ padding: "10px 12px", fontSize: 13, color: "#94a3b8" }}>No options</div>
              ) : (
                <>
                  <label style={{ display: "flex", alignItems: "center", gap: 8, padding: "7px 10px", borderRadius: 7, cursor: "pointer", fontSize: 13, fontWeight: 700, color: "#0f172a", borderBottom: "1px solid #f1f5f9", marginBottom: 2 }}>
                    <input type="checkbox" checked={allChecked} onChange={(e) => this.selectAll(e.target.checked)} style={{ accentColor: "#6366f1" }} />
                    Select All
                  </label>
                  {options.map((o) => {
                    const on = value.some((v) => String(v) === String(o.value));
                    return (
                      <label key={o.value} style={{ display: "flex", alignItems: "center", gap: 8, padding: "7px 10px", borderRadius: 7, cursor: "pointer", fontSize: 13, color: "#334155", background: on ? "#eef2ff" : "transparent" }}>
                        <input type="checkbox" checked={on} onChange={() => this.toggle(o.value)} style={{ accentColor: "#6366f1" }} />
                        {o.label}
                      </label>
                    );
                  })}
                  {value.length > 0 && (
                    <div onClick={() => this.selectAll(false)} style={{ padding: "7px 10px", fontSize: 12, fontWeight: 600, color: "#dc2626", cursor: "pointer", borderTop: "1px solid #f1f5f9", marginTop: 4 }}>Clear all</div>
                  )}
                </>
              )}
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default MultiSelectDropdown;
